export function LeadCard({ l }) {
  return (
    <div className="card-federal p-6" data-testid={`lead-${l.id}`}>
      <div className="flex justify-between items-start mb-3">
        <div>
          <span className="badge-federal">{l.type}</span>
          {l.is_veteran && <span className="ml-2 badge-gold">Veteran</span>}
          {l.urgency && <span className="ml-2 badge-crimson">{l.urgency}</span>}
        </div>
        <div className="text-caption text-slate-500">{l.created_at?.slice(0,16)}</div>
      </div>
      <div className="grid md:grid-cols-2 gap-4 text-sm">
        <div><div className="text-caption text-slate-500">Referrer / Contact</div><div>{l.referrer_name || l.name} — <span className="text-slate-500">{l.referrer_email || l.email}</span></div><div className="text-slate-500">{l.referrer_org || l.organization || ""}</div></div>
        <div><div className="text-caption text-slate-500">Client / Case</div><div>{l.client_name || "—"}</div><div className="text-slate-500 capitalize">{l.case_type || ""}</div></div>
      </div>
      {(l.summary || l.message) && <div className="mt-3 pt-3 border-t border-slate-100 text-slate-700 text-sm whitespace-pre-wrap">{l.summary || l.message}</div>}
    </div>
  );
}
